import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import request from '../ct-request';

const useOrder = (orderId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchOrder() {
      dispatch({ type: 'accounts/updateCurrentOrder', payload: {} });
      const uri = `orders/${orderId}`;
      const ctOrder = await request({
        uri,
        options: {
          method: 'GET',
        },
      });

      dispatch({ type: 'accounts/updateCurrentOrder', payload: ctOrder });
    }
    try {
      if (orderId) {
        fetchOrder();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }, [dispatch, orderId]);
  return useSelector((state) => state.accounts.user.currentOrder);
};
export default useOrder;
